import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("InpageNavigationWidget", {
  title: "Inpage Navigation",
  attributes: {
    items: {
      title: "Items",
      description:
        "Optional: Manuell ausgewählte Elemente. Wenn gesetzt, werden nur diese angezeigt – unabhängig von 'Childs from'.",
    },
    childsFrom: {
      title: "Childs from",
      description:
        "Optional: Quelle für die Navigationseinträge. Wenn 'Items' leer ist, werden die Kinder dieses Objekts verwendet. Falls nicht gesetzt, werden die Kinder des aktuellen Objekts genutzt.",
    },
    sticky: {
      title: "Stick to top",
      description:
        "If inside a Section, the navigation will stick to the top of the screen on scrolling inside the Section. If it is added ",
    },
    largeTopMargin: {
      title: "Large Top Margin ",
      description:
        "If the inpage navigation is placed directly after a page Header, more margin is needded to prevent overlapping.",
    },
  },
  properties: ["childsFrom", "elements", "internal"],
  propertiesGroups: [
    {
      title: "Options",
      properties: ["direction", "sticky", "largeTopMargin"],
      key: "inpage-options",
    },
    {
      title: "Old Items (will be removed in future versions)",
      properties: ["items"],
      key: "inpage-old-items",
    },
  ],
});
